import axios from 'axios';
import {parseStorage} from '../../action'


export const NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS_SUCCESS'
export const NOTIFICATIONS_DETAIL_SUCCESS = 'NOTIFICATIONS_DETAIL_SUCCESS'

export const NOTIFICATIONS_TC_SUCCESS = 'NOTIFICATIONS_POPUP_TC_SUCCESS'


const API_URL = process.env.REACT_APP_API_URL
const API_MAIN =  process.env.REACT_APP_API_MAIN

export function getCampaigns(){
  const auth = new parseStorage()
  return dispatch => {
    dispatch({
      type: 'GET_CAMPAIGNS_DASHBOARD',
      payload: 
        axios.post(API_URL + `/campaigns?page=1`,{view: 5},{
          headers: {
            'Authorization' : 'Bearer ' + auth.token,
            'Accept' : 'application/json',
          },         
      })
    })
  } 
}

export function getUserDetail(){
  const auth = new parseStorage()
  return dispatch => {
    dispatch({
      type: 'GET_USER_DETAIL',
      payload: 
        axios.get(API_MAIN + `/login/detail`,{
          headers: {
              'Authorization' : 'Bearer ' + auth.token,
              'Accept' : 'application/json',
          },        
      })
    })
  } 
}

export function updateShowTC(data){
    return {
        type: NOTIFICATIONS_TC_SUCCESS,
        data
    }
}

export function updateNotificationTC(data){
    return dispatch => {
        const auth = new parseStorage()    
        axios.post(API_MAIN + '/influencer/notification/popup',data,
        {
            headers: {
                'Authorization' : 'Bearer ' + auth.token,
                'Accept' : 'application/json',
            }
        }).then(function(res){
            console.log("RES :",res)
        }).catch(function(err){
            console.log("ERR :",err)
        })    
    }
}

function getNotificationSuccess(data){
    return {
        type: NOTIFICATIONS_SUCCESS,
        data
    }
}

function getNotificationDetailSuccess(data){
    return {
        type: NOTIFICATIONS_DETAIL_SUCCESS,
        data
    }
}
export function getNotification(){
    return dispatch => {
        const auth = new parseStorage()    
        axios.get(API_MAIN + '/influencer/notifications',{
            headers: {
                'Authorization' : 'Bearer ' + auth.token,
                'Accept' : 'application/json',
            }
        }).then(function(res){
            dispatch(getNotificationSuccess(res.data.results))
        }).catch(function(err){
            // if(err.response.status === 401){
            //     window.location.href = '/login'  
            // }  
        })    
    }
}

export function getNotificationDetail(filter){
    return dispatch => {
        const auth = new parseStorage()    
        axios.post(API_MAIN + `/influencer/notification/details?page=${filter.page}`,{
            view: filter.view
        }, {
            headers: {
                'Authorization' : 'Bearer ' + auth.token,
                'Accept' : 'application/json',
            }
        }).then(function(res){            
            dispatch(getNotificationDetailSuccess(res.data.results))
        }).catch(function(err){
            
        })    
    }
}

export function notifDestroy(filter){
    return dispatch => {
        const auth = new parseStorage()    
        axios.post(API_MAIN + `/influencer/notification/destroy`,{            
        }, {
            headers: {
                'Authorization' : 'Bearer ' + auth.token,
                'Accept' : 'application/json',
            }
        }).then(function(res){            
            dispatch(getNotificationDetail(filter))
        }).catch(function(err){
            
        })    
    }
}